import { SC } from "../helper/ServerCall";

export const orderService = {
  storeOrder,
  getOrdersPagination,
  getOrderResourceFormats,
  getOrder,
  storeOrderResource,
  getOrderResources,
  deleteOrderResource,
  getTripOrderUsers,
  getFollowingOrderUsers,
  getSpecialUser,
  deleteOrderUser,
  updateOrderUser,
  createSpecialUser,
  updateSpecialUser,
  approveOrderUpload,
  getOrderSettings,
  changeOrderHashTag,
  changeOrderMessaging,
  updateOrderOpenPhotoUpload,
  updateOrderMaxPhotoUpload,
  updateOrderAutoApprovePhotos,
  updateApproveOrderVideoUpload,
  updateOrderUploadCutOffDate,
  updateShippingDetails,
  updateProjectCameraShipDate,
  updateOrderVideoTitles,
  toggleOrderEquipmentStatus,
  processShipStatus,
  updateOrderDetail,
  updatePricingDetail,
  processCamerasToShip,
  orderImages,
  getRequiredAssets,
  allOrderImagesByPhase,
  recentlyProcessedOrder,
  storeEditorOrderImages,
  changeImagePhase,
  assignUserToOrder,
  getImagePhase,
  updateOrderSettings,
  storeOrderImages,
  getOrderUploadInfo,
  getOrderItems,
  getOrderItems,
  updateOrderShippingVia,
  updateOrderGrid,
  bulkEditOrder,
};

function storeOrder(orderData) {
  return SC.postCall("order", orderData);
}

function getOrdersPagination(page, filter, sort, pageSize, searchData) {
  return SC.postCall("getOrders?page=" + page + "&filter=" + filter + "&sort=" + sort + "&pageSize=" + pageSize, searchData);
}

function getOrderResourceFormats() {
  return SC.getCall("getOrderResourceTypes");
}

function getOrder(orderId) {
  return SC.getCall("order/" + orderId);
}

function storeOrderResource(resource, id) {
  return SC.postCall("storeOrderResource/" + id, resource);
}

function getOrderResources(orderId) {
  return SC.getCall("getOrderResources/" + orderId);
}

function deleteOrderResource(id) {
  return SC.deleteCall("orderResourceDelete/" + id);
}

function getTripOrderUsers(id, page, filter, sort, pageSize) {
  return SC.getCall("getTripOrderUsers/" + id + "?page=" + page + "&filter=" + filter + "&sort=" + sort + "&pageSize=" + pageSize);
}

function getFollowingOrderUsers(id, page, filter, sort, pageSize) {
  return SC.getCall("getFollowingOrderUsers/" + id + "?page=" + page + "&filter=" + filter + "&sort=" + sort + "&pageSize=" + pageSize);
}

function getSpecialUser(orderId) {
  return SC.getCall("getSpecialOrderUser/" + orderId);
}

function deleteOrderUser(id) {
  return SC.deleteCall("deleteOrderUser/" + id);
}

function updateOrderUser(id, userData) {
  return SC.putCall("updateOrderUser/" + id, userData);
}

function createSpecialUser(userData) {
  return SC.postCall("createSpecialUser", JSON.stringify(userData));
}

function updateSpecialUser(userData) {
  return SC.putCall("updateSpecialUser", userData);
}

function approveOrderUpload(id, value) {
  const data = { value: value };
  return SC.putCall("approveOrderUpload/" + id, data);
}

function getOrderSettings(id) {
  return SC.getCall("getOrderSettings/" + id);
}

function changeOrderHashTag(id, value) {
  const data = { value: value };
  return SC.putCall("changeOrderHashTag/" + id, data);
}

function changeOrderMessaging(id, data) {
  return SC.putCall("updateOrderMessaging/" + id, data);
}

function updateOrderOpenPhotoUpload(id, value) {
  const data = { value: value };
  return SC.putCall("updateOrderOpenPhotoUpload/" + id, data);
}

function updateOrderMaxPhotoUpload(id, value) {
  const data = { value: value };
  return SC.putCall("updateOrderMaxPhotoUpload/" + id, data);
}

function updateOrderAutoApprovePhotos(id, value) {
  const data = { value: value };
  return SC.putCall("updateOrderAutoApprovePhotos/" + id, data);
}

function updateApproveOrderVideoUpload(id, value) {
  const data = { value: value };
  return SC.putCall("updateApproveOrderVideoUpload/" + id, data);
}

function updateOrderUploadCutOffDate(id, value) {
  const data = { value: value };
  return SC.putCall("updateOrderUploadCutOffDate/" + id, data);
}

function updateShippingDetails(orderId, Data) {
  return SC.putCall("updateShippingDetails/" + orderId + "/update", Data);
}

function updateProjectCameraShipDate(orderId, Data) {
  return SC.putCall("updateOrderDate/" + orderId + "/update", Data);
}

function updateOrderVideoTitles(orderId, Data) {
  return SC.putCall("updateOrderVideoTitles/" + orderId + "/update", Data);
}

function toggleOrderEquipmentStatus(orderId, data) {
  return SC.putCall("toggleOrderEquipmentStatus/" + orderId + "/update", data);
}

function processShipStatus(orderId, data) {
  return SC.putCall("processShipStatus/" + orderId, data);
}

function updateOrderDetail(data, id) {
  return SC.putCall("order/" + id, data);
}

function updatePricingDetail(data, id) {
  return SC.putCall("updatePricingDetails/" + id + "/update", data);
}

function processCamerasToShip(page, filter, sort, pageSize, brand_id, orders_type, advancedSearchFilters) {
  return SC.postCall(`camerasToShip?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&brand_id=${brand_id}&orders_type=${orders_type}`, advancedSearchFilters);
}

function orderImages(orderId, version_type, tabName, page, filter, sort, pageSize, userRole) {
  return SC.postCall(`images/${orderId}/${version_type}/${tabName}?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`, { userRole });
}

function getRequiredAssets(orders) {
  return SC.postCall(`calculateRequiredAssets`, orders);
}

function allOrderImagesByPhase(orderId, version_type, tabName) {
  return SC.getCall(`allImagesByPhase/${orderId}/${version_type}/${tabName}`);
}

function recentlyProcessedOrder(page, filtered, sort, pageSize) {
  return SC.postCall(`recentlyProcessedCameras?page=${page}&filtered=${filtered}&sort=${sort}&pageSize=${pageSize}&agency_id=1`);
}

function storeEditorOrderImages(imagesData, orderId, folder, callback) {
  return SC.postCall(`storeOrderImages/${orderId}/${folder}`, imagesData, (response)=>{
      callback(response);
    }
  );
}

function changeImagePhase(orderId, phase, bit) {
  return SC.getCall(`changeImagePhase/${orderId}/${phase}/${bit}`);
}

function getImagePhase(orderId, phase) {
  return SC.getCall(`getImagePhase/${orderId}/${phase}`);
}

function assignUserToOrder(orderId, data) {
  return SC.postCall(`assignUserToOrder/${orderId}`, data);
}

function updateOrderSettings(orderId, data) {
  return SC.putCall(`updateOrderSettings/${orderId}`, data);
}

function storeOrderImages(data, orderId) {
  return SC.postCall(`storeOrderImages/${orderId}`, data);
}

function getOrderUploadInfo(orderId) {
  return SC.getCall(`getOrderUploadInfo/${orderId}`);
}

function getOrderItems(orderId) {
  return SC.getCall(`getOrderItems/${orderId}`);
}

function updateOrderShippingVia(data) {
  return SC.postCall(`orders/updateShippingVia`, data);
}

function updateOrderGrid(data){
  return SC.postCall('orders/update-order-grid-fields', data)
}

function bulkEditOrder(data){
  return SC.postCall('orders/bulk-edit', data)
}


// WEBPACK FOOTER //
// ./src/services/order.js